import { useState } from "react";
import TopBar from "./TopBar";
import Sidebar from "./Sidebar";
import { useUserState } from './Mode';

const ContentWrapper = ({ children, className }) => {
    const { theme,} = useUserState();
    const [isSidebarActive, setIsSidebarActive] = useState(false); // State to manage sidebar class

    const toggleSidebar = () => {
        setIsSidebarActive(prevState => !prevState); // Toggle the sidebar class
    };

    return (
        <div id="page" className={`${theme === 'light' ? 'light-mode' : ''}`}>
            <TopBar/>
            <div id="content-wrapper" className={ className }>
                <Sidebar isActive={isSidebarActive} toggleSidebar={toggleSidebar}/>
                <div id="main-content" className="tif-bg-color-alpha tif-bg-light-color-white tif-color-white tif-light-color-november flex-grow-1">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ContentWrapper;